export default __webpack_public_path__ + "static/media/jpmLogo.d9ae8b6b.png";